import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c16e927"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "correct" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bigtitle" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line1" }, "思考")
], -1))
const _hoisted_3 = {
  class: "swiper-container",
  ref: "Carouseltop"
}
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = { class: "swiper-slide" }
const _hoisted_6 = { class: "boxTail" }
const _hoisted_7 = { class: "leftright" }
const _hoisted_8 = { class: "sikao1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_10 = { class: "swiper-slide" }
const _hoisted_11 = { class: "boxTail" }
const _hoisted_12 = { class: "leftright" }
const _hoisted_13 = { class: "sikao2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle2" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_15 = { class: "swiper-slide" }
const _hoisted_16 = { class: "boxTail" }
const _hoisted_17 = { class: "leftright" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "sikao3" }, " 辅舒良属于指南推荐的第二代鼻用激素，具有高亲脂性、与受体结合力强、抗炎活性更强、生物利用度低等特点；首次使用最快2-4小时起效，显著改善鼻部、眼部症状；每日仅需用一次，日治疗费用更合适，更易提高患者依从性 ")
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle3" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiexi" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "daan" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dadesc" })
], -1))
const _hoisted_22 = { class: "ip" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span", null, "111111111111111中华耳鼻咽喉头颈外科杂志2022 年2月第57卷第2期，106-129"),
  /*#__PURE__*/_createElementVNode("span", null, "编号PM-CN-FLX-23-00149，有效期至24 Apr 2028"),
  /*#__PURE__*/_createElementVNode("div", null, " 本材料并非广告，旨在向且仅向医疗保健专业人士提供科学信息。如果您不是医疗保健专业人士，请勿阅读或传播其中的内容。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_van_image, {
                  class: "rightImg",
                  width: ".64rem",
                  height: ".6133rem",
                  src: require('../assets/duigou.png')
                }, null, 8, ["src"])
              ]),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_van_image, {
                      width: "5rem",
                      height: "3.1467rem",
                      src: require('../assets/sikao1.png')
                    }, null, 8, ["src"])
                  ])
                ])
              ])
            ]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_van_image, {
                  class: "rightImg",
                  width: ".64rem",
                  height: ".6133rem",
                  src: require('../assets/duigou.png')
                }, null, 8, ["src"])
              ]),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_van_image, {
                      width: "5rem",
                      height: "2rem",
                      src: require('../assets/sikao2.png')
                    }, null, 8, ["src"])
                  ])
                ])
              ])
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_van_image, {
                  class: "rightImg",
                  width: ".64rem",
                  height: ".6133rem",
                  src: require('../assets/duigou.png')
                }, null, 8, ["src"])
              ]),
              _hoisted_18
            ]),
            _hoisted_19
          ])
        ]),
        _hoisted_20
      ], 512),
      _hoisted_21
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_van_image, {
        class: "footBtn",
        onClick: $options.nexStep,
        width: "5.64rem",
        height: "1.3333rem",
        src: require('../assets/jxbtn.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ]),
    _hoisted_23
  ], 64))
}